import React from 'react';
import './faq.scss';

const FAQ = () => {
  return (
    <div className="faqs" id="questions">
      <div className="item">
        <h5>What is this?</h5>
        <p>This is a simple app to compare places (up to 4). You can make the judgment based on the rating, reviews </p>
      </div>

      <div className="item">
        <h5>Where is the data coming from?</h5>
        <p>All the places data is based on Google Maps. The data is received from Google Places API and presented without any alteration other than UI styling</p>
      </div>

      <div className="item">
        <h5>What details can be seen here?</h5>
        <p>
          All the places details are provided by Google. 
          In a perfect scenario, you can see the ratings, 5 reviews, timings, contact number, maps link and website details. 
          But availablilty of all the data are not promised.
        </p>
      </div>

      <div className="item">
        <h5>But why?</h5>
        <p>Side by side view of places can give a pleasant way to look at them. We can easily make out the differences and details about them.</p>
      </div>

      <div className="item">
        <h5>Only 5 reviews?</h5>
        <p>Yes. That's all Google gives</p>
      </div>

      <div className="item">
        <h5>I cannot search for places</h5>
        <p>It is possible that credit limit for the Google Places API has exceeded. </p>
      </div>

      <div className="item">
        <h5>This is cool. How can I contribute?</h5>
        <p>
          For the time being, let me know what you like about this and what more features would you like to see on this app. 
          <a
            href="https://twitter.com/georgejustin22"
            rel="noopener noreferrer"
            target="_blank"
            style={{marginLeft: 4}}
          >
            Hit me
          </a>
        </p>
      </div>

    </div>
  )
}
export default FAQ;